import React, { useState } from "react";
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// FAQ Data
const helpData = {
  TransactionStatus: [
    {
      question: "How do I check the current status of my transaction?",
      answer: `• You can review the status of your transaction and other related information in the ‘Mini Statement’ feature.

• In the mini statement page, to view the details of a specific transaction, click on it.`,
    },
    {
      question: "What if my transaction fails?",
      answer:
        "In case the transfer fails, the full amount will be refunded back to your wallet within 3 to 7 working Days.",
    },
    {
      question: "What if my transaction goes to pending state?",
      answer: `• In case your transaction is pending, be assured that your money is safe with us.

• Your pending transfer amount will be listed in the “pending” queue.

• Once the transfer is completed, we will let you know via SMS and you can check the status in the mini statement.

• If NOT, the amount will be reflected in your wallet within 3 to 5 working Days.`,
    },
  ],
};

const TransactionStatus = ({ selectedSection = "TransactionStatus" }) => {
  const questions = helpData[selectedSection] || [];
  const [openIndex, setOpenIndex] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const toggleAnswer = (index) =>
    setOpenIndex((prev) => (prev === index ? null : index));

  return (
    <Box width="100%">
      {/* Top Banner */}
      <Box
        sx={{
          width: "100%",
          height: { xs: 160, sm: 200, md: 260 },
          // backgroundColor: "#d0ddee",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: { xs: 1, sm: 3 },
        }}
      >
        <Box
          component="img"
          src="/Assets/TransactionRelatedInformation.jpg"
          alt="Transaction Status Banner"
          sx={{
            width: "100%",
            maxWidth: 800,
            height: "100%",
            objectFit: "cover",
            borderRadius: "0 0 10px 10px",
          }}
        />
      </Box>

      {/* Heading */}
      <Box mt={3} display="flex" justifyContent="center">
        <Typography
          variant={isMobile ? "h6" : "h5"}
          fontWeight="bold"
          color="black"
        >
          Transaction Status
        </Typography>
      </Box>

      {/* FAQ Section */}
      <Box
        maxWidth="900px"
        mx="auto"
        px={{ xs: 1.5, sm: 2, md: 3 }}
        mt={2}
        py={2}
      >
        <List disablePadding>
          {questions.map((item, index) => (
            <Box
              key={index}
              sx={{
                border: "1px solid #ddd",
                borderRadius: 2,
                mb: 2,
                overflow: "hidden",
                boxShadow:
                  openIndex === index ? "0 2px 8px rgba(0,0,0,0.06)" : "none",
                transition: "box-shadow 0.2s ease-in-out",
              }}
            >
              <ListItemButton
                onClick={() => toggleAnswer(index)}
                sx={{
                  borderBottom: "1px solid #eee",
                  px: 2,
                  py: 1.5,
                  backgroundColor:
                    openIndex === index ? "#e0f7fa" : "transparent",
                  "&:hover": {
                    backgroundColor:
                      openIndex === index ? "#b2ebf2" : "#f9f9f9",
                  },
                }}
              >
                <ListItemText primary={item.question} />
                {openIndex === index ? (
                  <ExpandMoreIcon sx={{ fontSize: 18 }} />
                ) : (
                  <ArrowForwardIosIcon sx={{ fontSize: 14 }} />
                )}
              </ListItemButton>

              <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
                <Box px={3} py={2} bgcolor="#fafafa">
                  <Typography
                    variant="body2"
                    sx={{ whiteSpace: "pre-wrap", lineHeight: 1.6 }}
                  >
                    {item.answer}
                  </Typography>
                </Box>
              </Collapse>
            </Box>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default TransactionStatus;
